import React from 'react'

const SmilyIcon = ({ color = '#000', className = '' }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" className={className} viewBox="0 0 15.5 15.5">
      <path
        data-name="Path 926"
        d="M9 14a3.019 3.019 0 0 0 .864 1.219 3.336 3.336 0 0 0 4.252.031A3.026 3.026 0 0 0 15 14.044"
        style={{
          strokeLinejoin: 'round',
          fill: 'none',
          stroke: color,
          strokeLinecap: 'round',
          strokeWidth: '1.5px',
        }}
        transform="translate(-4.25 -4.25)"
      />
      <path
        data-name="Path 927"
        d="M19 12a7 7 0 1 1-2.05-4.95A7 7 0 0 1 19 12z"
        style={{
          fillRule: 'evenodd',
          strokeLinejoin: 'round',
          fill: 'none',
          stroke: color,
          strokeLinecap: 'round',
          strokeWidth: '1.5px',
        }}
        transform="translate(-4.25 -4.25)"
      />
      <path
        data-name="Path 928"
        d="M9 11v-1"
        style={{ fill: 'none', stroke: color, strokeLinecap: 'round', strokeWidth: '1.5px' }}
        transform="translate(-4.25 -4.25)"
      />
      <path
        data-name="Path 929"
        d="M15 11v-1"
        style={{ fill: 'none', stroke: color, strokeLinecap: 'round', strokeWidth: '1.5px' }}
        transform="translate(-4.25 -4.25)"
      />
    </svg>
  )
}

export default SmilyIcon
